import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthOperatorService } from '../services/auth-operator.service';

@Injectable({
  providedIn: 'root'
})
export class AuthOperatorGuard implements CanActivate {

  constructor(
    private auth: AuthOperatorService,
    private router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.auth.isLoggedIn) {
      return true;
    }
    this.router.navigate(['/operador/login']);
    return false;
  }
}
